import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
  Button,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import Scrollbar from "../components/scrollbar";
import { get, del } from "src/utils/networkUtils";
import HammerSmashTable from "src/components/hammer-smash/HammerSmashTable";
import { useNavigate } from "react-router-dom";
// ----------------------------------------------------------------------

export default function HammerSmashListPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeCampaigns, setActiveCampaigns] = useState(null);
  const [inactiveCampaigns, setInactiveCampaigns] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [campaignToDelete, setCampaignToDelete] = useState(null);

  const refreshCampaigns = () => {
    get(`/admin/hammer-smash?status=active&limit=100`).then(function (response) {
      setActiveCampaigns(response.campaigns);
    });
    get(`/admin/hammer-smash?status=inactive&limit=100`).then(function (response) {
      setInactiveCampaigns(response.campaigns);
    });
  };

  useEffect(() => {
    refreshCampaigns();
  }, []);

  const handleCreateCampaign = () => {
    navigate('/dashboard/hammer-smash/campaign');
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleDeleteClick = (campaign) => {
    setCampaignToDelete(campaign);
    setDeleteDialogOpen(true);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setCampaignToDelete(null);
  };

  const handleDeleteConfirm = () => {
    if (campaignToDelete) {
      setLoading(true);
      del(`/admin/hammer-smash/${campaignToDelete.campaignId}`)
        .then(function () {
          refreshCampaigns();
        })
        .catch(function (error) {
          console.error('Error deleting hammer smash campaign:', error);
        })
        .finally(function () {
          setLoading(false);
          setDeleteDialogOpen(false);
          setCampaignToDelete(null);
        });
    }
  };

  const isLoading = () => {
    return activeCampaigns === null || inactiveCampaigns === null || loading;
  };

  return (
    <>
      <Helmet>
        <title>Hammer Smash</title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Hammer Smash
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreateCampaign}
          >
            + Hammer Smash
          </Button>
        </Stack>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Active" />
            <Tab label="Draft / Inactive" />
          </Tabs>
        </Box>

        <Card>
          {isLoading() ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <HammerSmashTable
                campaigns={activeTab === 0 ? activeCampaigns : inactiveCampaigns}
                onDelete={handleDeleteClick}
              />
            </Scrollbar>
          )}
        </Card>
      </Container>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Delete Hammer Smash
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete "{campaignToDelete?.title}"? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
